const n = {
  name: "ChevronDownSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00015 8.58564L12.0002 12.5856L16.0002 8.58564L17.4144 9.99985L12.0002 15.4141L6.58594 9.99985L8.00015 8.58564Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as ChevronDownSmall
};
